import React from 'react'
import {Grid, Typography} from 'antd'
import classNames from 'classnames'
import {Icon} from '@/components/dumb/Icon'
import {Card} from '@/components/dumb/Card'
import {SliderPreviewItemProps} from './props'
import styles from './styles.scss'
import {CAROUSEL, CAROUSEL_SUBTITLE} from '@/constants/playwright-ids'

const {Text, Title} = Typography

export const CarouselWidgetItem: React.FC<SliderPreviewItemProps> = ({
    title,
    subtitle,
    description,
    linkText,
    onLinkClick,
    backgroundColor,
    href,
    features = []
}) => {
    const screens = Grid.useBreakpoint()
    const isMobile = screens.xs
    const isTablet = screens.sm || screens.md
    const isDesktop = screens.lg || screens.xl || screens.xxl

    const hasHorizontalLayout = backgroundColor === 'violet' && features.length > 0

    return (
        <Card
            className={classNames(
                styles.card,
                {[styles.cardMobile]: isMobile},
                {[styles.cardTablet]: isTablet},
                {[styles.cardDesktop]: isDesktop},
                {[styles.cardYellow]: backgroundColor === 'yellow'},
                {[styles.cardBlue]: backgroundColor === 'blue'},
                {[styles.cardLightViolet]: backgroundColor === 'violet'},
                {[styles.cardLightVioletMobile]: backgroundColor === 'violet' && isMobile}
            )}
            data-test-id={CAROUSEL}
        >
            <div
                className={classNames(styles.body, {
                    [styles.bodyMobile]: isMobile,
                    [styles.bodyHorizontal]: hasHorizontalLayout,
                    [styles.bodyHorizontalMobile]: hasHorizontalLayout && isMobile
                })}
            >
                <div className={styles.content}>
                    <Text className={styles.title} data-test-id={CAROUSEL_SUBTITLE}>
                        {subtitle}
                    </Text>
                    <Title
                        className={classNames(styles.subtitle, {[styles.subtitleMobile]: isMobile})}
                        level={3}
                    >
                        {title}
                    </Title>
                    <Text className={styles.text}>{description}</Text>
                    <a
                        target={'_blank'}
                        href={href}
                        onClick={onLinkClick}
                        className={styles.link}
                        rel='noreferrer'
                    >
                        {linkText}
                        <Icon type={'arrow_right'} />
                    </a>
                </div>
                {features.length > 0 && (
                    <div
                        className={classNames(styles.features, {
                            [styles.featuresMobile]: isMobile
                        })}
                    >
                        {features.map((feature, index) => (
                            <div key={index} className={styles.feature}>
                                <Text className={styles.featureText}>{feature}</Text>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </Card>
    )
}
